import { SaasApiClient } from '@fourthwall/services/dist/SaasApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useSubscriptionPlansQuery = createQueryHook(SaasApiClient.getSubscriptionPlans, {
  queryKey: ['subscriptionPlans'],
})
